export enum StoreEvent {
  INITIALISE = 'INITIALISE',
  CREATE_SESSION = 'CREATE_SESSION',
  SET_SESSION = 'SET_SESSION',
  SESSION_CREATION_FAILED = 'SESSION_CREATION_FAILED',
  GET_CATALOGUE = 'GET_CATALOGUE',
  SET_CATALOGUE = 'SET_CATALOGUE',
  GET_CATALOGUE_FAILED = 'GET_CATALOGUE_FAILED',
  PROCESS_URL_PARAMS = 'PROCESS_URL_PARAMS',
  SET_URL_PARAM_RESULTS = 'SET_URL_PARAM_RESULTS',
  SAVE_APPLIANCE_MODEL_RESULTS = 'SAVE_APPLIANCE_MODEL_RESULTS',
  NEXT = 'NEXT',
  BACK = 'BACK',
  SUBMIT = 'SUBMIT',
  QUOTE_FAILED = 'QUOTE_FAILED',
  SET_QUOTE = 'SET_QUOTE',
  NO_QUOTE_REG_ONLY = 'NO_QUOTE_REG_ONLY',
  REG_ONLY = 'REG_ONLY',
  SET_CONCIERGE_DATA = 'SET_CONCIERGE_DATA',
  SET_CPG_DATA = 'SET_CPG_DATA',
  CONTINUE_TO_CHECKOUT = 'CONTINUE_TO_CHECKOUT',
  SET_CHECKOUT = 'SET_CHECKOUT',
  CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS',
  CHECKOUT_FAILED = 'CHECKOUT_FAILED',
  RESTORE_SESSION = 'RESTORE_SESSION',
  START_SESSION_TIMER = 'START_SESSION_TIMER',
  SESSION_EXPIRED = 'SESSION_EXPIRED',
}
